import { environment } from './../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL_UTIL } from 'src/app/@core/utils';
import { Observable } from 'rxjs';
import { TimecardApiResponse } from '../../models';
import { HttpStatus } from '../../models/add-employee.modal';
import { AddPhaseResponse, PhaseDetails } from '../../models/add-phase.modal';

@Injectable({
  providedIn: 'root'
})
export class AddPhaseService {

  constructor(private readonly httpClient: HttpClient) { }

  getPhaseList(jobScheduleId: string, searchText: string): Observable<AddPhaseResponse> {
    const params = new HttpParams().set('JobScheduleId', jobScheduleId).set('searchText', searchText);
    return this.httpClient.get<AddPhaseResponse>(`${API_URL_UTIL.foreman.getAllActivePhasesByJobScheduleId}`, { params });
  }

  updatePhase(JobScheduleId: string, email: string, phaseDetails: Array<PhaseDetails>, startDate: string, noActionForTAndMPhase: boolean,isDeliveries:boolean,isConcrete:boolean): Observable<HttpStatus> {
    const params = new HttpParams().set('JobScheduleId', JobScheduleId).set('LoggedInUser', `${email}`).set('Startdate', startDate).set('NoActionForTAndMPhase', noActionForTAndMPhase).set('IsDeliveries',isDeliveries).set('IsConcrete',isConcrete);
    return this.httpClient.post<HttpStatus>(API_URL_UTIL.foreman.savePhasesByJobScheduleId, { phaseDetails }, { params });
  }

  getCurrentPhaseList(JobScheduleId: string, startDate: string, restrictedTandM: boolean): Observable<TimecardApiResponse> {
    const params = new HttpParams().set('JobScheduleId', JobScheduleId).set('startDate', `${startDate}`).set('restrictedTandM', restrictedTandM);
    return this.httpClient.get<TimecardApiResponse>(`/JobSchedule/${API_URL_UTIL.foreman.getCrewPhaseDetailsByJobScheduleId}`, { params });
  }

}
